import axios from 'axios';

const termsConditionsConfig = window.mcflyTermsConditions;

if (termsConditionsConfig.regionApiUrl && Object.keys(termsConditionsConfig.termsAndConditions).length) {
	const redirectByRegion = (region = '') => {
		if (region && region in termsConditionsConfig.termsAndConditions) {
			window.location.assign(termsConditionsConfig.termsAndConditions[region]);
		} else {
			window.location.assign(termsConditionsConfig.termsAndConditions[Object.keys(termsConditionsConfig.termsAndConditions)[0]]);
		}
	};

	axios
		.get(termsConditionsConfig.regionApiUrl)
		.then((response) => {
			const region = response.data.region.toLowerCase();
			redirectByRegion(region);
		})
		.catch(() => {
			redirectByRegion();
		});
}
